const botName = 'DotYeti Bot';

export default botName;
